import { deepMerge } from 'js/utils/Utils'

const defaults = {
  instanceName: 'ScrollHelper',
  className: {
    stopped: 'is-scroll-stopped',
  },
}

class ScrollHelper {
  constructor(options = {}) {
    this.$wrapper = window
    this.$conatiner = document.body
    this.st = 0
    this.isStopping = false
    deepMerge(this, defaults, options)
  }

  // init() {
  // }

  stop() {
    if (this.isStopping) return

    this.isStopping = true
    this.$conatiner.classList.add(this.className.stopped)
    // this.st = this.$wrapper[this.scrollProperty]
    this.st = document.documentElement.scrollTop || document.body.scrollTop

    this.addStyle()
  }

  restart() {
    if (!this.isStopping) return

    this.isStopping = false
    this.$conatiner.classList.remove(this.className.stopped)
    this.removeStyle()
  }

  reset() {
    if (this.isStopping) {
      this.removeStyle()
      this.st = 0
      this.isStopping = false
    }
  }

  get scrollProperty() {
    if (this.$wrapper === window) {
      return 'scrollY'
    } else {
      return 'scrollTop'
    }
  }

  addStyle() {
    deepMerge(this.$conatiner.style, {
      position: 'fixed',
      top: `${-this.st}px`,
      left: 0,
      overflow: 'clip',
    })

    document.scrollingElement.scrollTop = 0
  }

  removeStyle() {
    deepMerge(this.$conatiner.style, {
      position: '',
      top: '',
      left: '',
      overflow: '',
    })

    document.scrollingElement.scrollTop = this.st
  }
}

export default new ScrollHelper()